import axios from "axios";
import { checkStatus, parseJSON } from "./responseHandler";
import { SessionHelper } from "./session";

// Make an api call

export default async (baseUrl, endpoint, method = "post", body) => {
  return axios(`${baseUrl}${endpoint}`, {
    method,
    data: body ? JSON.stringify(body) : null,
    headers: SessionHelper.getHeader(method)
  })
    .then(checkStatus)
    .then(parseJSON)
    .catch(error => {
      throw error;
    });
};
